import { on } from 'delegated-events'

export default class FileUpload {
    constructor() {
        this.getDom()
        this.bindEvents()
    }

    getDom() {
        this.fileInput = document.querySelector('.js-file-upload')
    }

    bindEvents() {
        on('change', '.js-file-upload', this.handleFileUpload.bind(this))
    }

    handleFileUpload(event) {
        const parent = event.target.parentNode
        const label = parent.querySelector('.form-upload__label')

        console.log(event.target.files[0].name)
        console.log(parent, label)

        const fileName = event.target.files[0].name
        if (fileName) {
            label.textContent = fileName
        }
    }
}
